import { Component } from "@angular/core";
import { TranslatePipe } from "@ngx-translate/core";
import { RouterLink } from "@angular/router";

@Component({
  selector: "app-reset-password-hint",
  imports: [TranslatePipe, RouterLink],
  templateUrl: "./reset-password-hint.component.html",
  styles: ``,
})
export class ResetPasswordHintComponent {}
